module.exports = __webpack_public_path__ + "assets/img/2.7e70ed03.png";